/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @next/next/no-img-element */
import { CircularProgress, Modal } from "@material-ui/core";
import JobListCard from "components/Job/JobListCard";
import ChevronDownIcon from "components/RevampFeedDetails/assets/ChevronDownIcon";
import CrossIcon from "components/RevampFeedDetails/assets/CrossIcon";
import InfoIcon from "components/RevampFeedDetails/assets/InfoIcon";
import React, { useEffect, useState } from "react";
import { isRHRUser, isUserLoggedIn } from "utils";
import { getCandidateFeed } from "utils/apiClientPrivate";
import CrossWithBGIcon from "components/RevampFeedDetails/assets/CrossWithBGIcon";
import clsx from "clsx";
import SuccessIcon from "components/RevampFeedDetails/assets/SuccessIcon";
import Image from "next/image";
import DOWNLOAD_APNA_APP_LINK from "constants/downloadApnaAppLink";
import ContactHRIcon from "components/RevampFeedDetails/assets/ContactHRIcon";
import { useWindowResize } from "utils/hooks";
import NextStepsIcon from "components/RevampFeedDetails/assets/NextStepsIcon";
import CustomImage from "components/Image";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import { useCandidateProgress } from "modules/candidate/profile/hooks/useCandidateProgress";
import LightBulbIcon from "components/RevampFeedDetails/assets/LightBulbIcon";
import ChevronLeftIcon from "assets/svgs/ChevronLeftIcon";
import ApplicationStatusBottomSheet from "./ApplicationStatusBottomSheet";

const ApplicationStatusScreen = ({
	job,
	similarJobs,
	isCandidateEligible,
	showApplicationStatusScreen,
	handleClose,
	requirementsData,
	isJobApplied,
	redirectToJobFeed,
	isContactHREnabled,
	eccScreenData,
}) => {
	const [isMobileView] = useWindowResize();
	const [jobFeedJobs, setJobFeedJobs] = useState([]);
	const [isJobFeedLoading, setIsJobFeedLoading] = useState(false);
	const [showIneligibleModal, setShowIneligibleModal] = useState(false);
	const [showDowloadAppModal, setShowDowloadAppModal] = useState(false);
	const [showWalkInEligibleBs, setShowWalkInEligibleBs] = useState(false);
	const [showAllWalkInDetails, setShowAllWalkInDetails] = useState(false);
	const isBulkJob = job?.job_format === "bulk";
	const walkInInterviewDetails = job?.job_details_section?.find(
		(section) => section?.id === "walk_in"
	);
	const {
		heading = "Your profile does not meet the job requirements",
		highlight_text: highlightText = "You have low chances of getting this job",
		data = null,
	} = requirementsData;
	const isWalkInJob = job?.is_walk_in;
	const { data: candidateProgressDetails, isLoading: isCandidateProgressLoading } =
		useCandidateProgress();
	const getJobFeed = async () => {
		setIsJobFeedLoading(true);
		const query = {
			c_id: isUserLoggedIn(),
		};
		try {
			const jobs = await getCandidateFeed(query);
			if (jobs?.data?.results?.jobs) {
				setJobFeedJobs(jobs?.data?.results?.jobs);
			}
		} catch (e) {
			console.log(e);
		}
		setIsJobFeedLoading(false);
	};
	const handleDownloadAppClick = () => {
		if (isMobileView) window.open(DOWNLOAD_APNA_APP_LINK);
		if (showWalkInEligibleBs) setShowWalkInEligibleBs(false);

		setShowDowloadAppModal(true);
	};
	useEffect(() => {
		if (!isCandidateEligible && isUserLoggedIn()) {
			getJobFeed();
		}
	}, []);

	const showSuccessSection =
		(isCandidateEligible && isJobApplied) ||
		(!isCandidateEligible && isJobApplied) ||
		(!isCandidateEligible && !isBulkJob && isRHRUser());

	const showSimilarJobs =
		isCandidateEligible && Array.isArray(similarJobs) && similarJobs?.length > 0;
	const showJobFeed =
		!isCandidateEligible && Array.isArray(jobFeedJobs) && jobFeedJobs?.length > 0;
	const showLowChanceElement = !isCandidateEligible && !isBulkJob && isRHRUser();

	const showOverlay =
		showIneligibleModal ||
		(showDowloadAppModal && !isMobileView) ||
		(showWalkInEligibleBs && !isMobileView);
	// In case of only location mismatch, we do not want to show primary CTA.
	const showPrimaryCTA = () => {
		let show = true;
		if (
			Array.isArray(requirementsData?.data?.requirements) &&
			requirementsData?.data?.requirements?.length > 0
		)
			requirementsData?.data?.requirements?.forEach((req) => {
				if (
					req?.title?.includes("Location") &&
					requirementsData?.data?.requirements?.length === 1
				) {
					show = false;
				}
			});
		return show;
	};
	const trackExploreBestMatchClick = () => {
		trackOnMixpanel("Explore best matching job button clicked", {
			web_logged_in: true,
			profile_enriched: (candidateProgressDetails as any)
				?.isCandidateOnboardingCompleted,
		});
	};
	const handleWalkInNudgeClick = () => {
		setShowWalkInEligibleBs(true);
	};
	const renderwalkInInterviewData = (walkInDetails) => {
		if (Array.isArray(walkInDetails) && walkInDetails?.length > 0) {
			if (showAllWalkInDetails) return walkInDetails;
			if (walkInDetails?.length > 2) {
				return walkInDetails?.slice(0, 2);
			}
			return walkInDetails;
		}
		return [];
	};
	return (
		<Modal open={showApplicationStatusScreen}>
			<div className="relative flex h-full w-full items-center justify-center md:static">
				<div
					className={clsx(
						"w-full overflow-auto bg-white md:relative md:max-h-[558px] md:max-w-[688px] md:rounded-[12px]",
						{
							// Scroll disabled if any modal is open
							"overflow-hidden": showOverlay,
							"min-h-fit": !(
								!isJobFeedLoading &&
								(showJobFeed || showSimilarJobs)
							),
							"h-full":
								!isJobFeedLoading && (showJobFeed || showSimilarJobs),
						}
					)}
				>
					<div
						className={clsx("bg-[#EAF8F4] p-[16px]", {
							"bg-[#FBD3D3] ": !showSuccessSection,
						})}
					>
						<div
							className="ml-auto w-max cursor-pointer"
							onClick={handleClose}
						>
							<CrossIcon fill="#190A28" size="24" />
						</div>

						<div className="my-[8px] flex flex-col items-center text-center">
							{showSuccessSection ? (
								<SuccessIcon />
							) : (
								<InfoIcon size={56} fill="#BD0A00" />
							)}
							{!isWalkInJob && (
								<>
									<p className="m-0 mt-[8px] text-md font-semibold leading-[24px] text-[#190A28]">
										{showSuccessSection
											? "Applied successfully"
											: "Sorry, you do not qualify"}
									</p>
									<p className="m-0 text-sm leading-[20px] text-[#190A28]">
										{showSuccessSection
											? "Your application is successfully sent to HR"
											: "Your current profile doesn't meet this job's requirements"}
									</p>
								</>
							)}
							{isWalkInJob && !isBulkJob && (
								<p className="m-0 mt-[8px] text-md font-semibold leading-[24px] text-[#190A28]">
									Registered for walk-in
								</p>
							)}
							{!showSuccessSection && isWalkInJob && isBulkJob && (
								<>
									<p className="m-0 mt-[8px] text-md font-semibold leading-[24px] text-[#190A28]">
										Sorry, you do not qualify
									</p>
									<p className="m-0 text-sm leading-[20px] text-[#190A28]">
										Your current profile doesn&apos;t meet this
										job&apos;s requirements
									</p>
								</>
							)}
						</div>

						{/* Company Info */}
						{isMobileView && (
							<div className="flex flex-wrap items-center justify-center gap-[8px]">
								{job?.organization?.logo_url && (
									<img
										src={job?.organization?.logo_url}
										className="h-[16px] w-[16px]"
										alt=""
									/>
								)}

								<p className="m-0 text-center text-sm leading-[20px] text-[#827485]">
									{job?.title}
								</p>
								<div className="h-1 w-1 rounded-full bg-black" />
								<p className="m-0 text-center text-sm leading-[20px] text-[#827485]">
									{job?.organization?.name}
								</p>
							</div>
						)}
						{showSuccessSection && (
							<div>
								<div
									className={clsx(
										"relative mt-[50px] flex flex-col items-center justify-center rounded-t-[8px] border border-solid bg-white p-[16px] md:mx-[108px]",
										{
											"border-b-0": showLowChanceElement,
											"rounded-b-[8px]":
												!showLowChanceElement || isWalkInJob,
										}
									)}
								>
									<div className="absolute top-[-36px] flex h-[72px] w-[72px] items-center justify-center rounded-full bg-white">
										{isContactHREnabled ? (
											<ContactHRIcon />
										) : (
											<NextStepsIcon />
										)}
									</div>
									<div className="mb-[16px] mt-[40px] text-center">
										{!isWalkInJob ? (
											<p className="m-0 text-[20px] font-bold leading-[28px] text-[#190A28]">
												{isContactHREnabled
													? "Contact HR now "
													: "Find out next steps"}
											</p>
										) : (
											<p className="m-0 text-[20px] font-bold leading-[28px] text-[#190A28]">
												{isCandidateEligible
													? "Download app and call HR to go for interview"
													: "Download app to call HR and check interview eligibility"}
											</p>
										)}
										{!isWalkInJob && (
											<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
												{isContactHREnabled
													? "Download the app to get HR contact info and track your job application"
													: "Download the app to track status of this job"}
											</p>
										)}
									</div>
									{/* Walk in ineligible nudge */}
									{isWalkInJob &&
										!isCandidateEligible &&
										eccScreenData?.body?.highlighter?.text && (
											<div
												className="mb-[16px] flex w-full cursor-pointer gap-[12px] rounded-[8px]  border border-solid border-[#f7e07e4c] bg-gradient-to-r from-[#fff9db00] to-[#FFF9DB] p-[12px]"
												onClick={() => handleWalkInNudgeClick()}
											>
												<InfoIcon fill="#AA4900" />
												<div className="flex-1">
													<p className="m-0 text-[12px] leading-[16px] text-[#AA4900] md:text-[14px] md:leading-[20px]">
														{eccScreenData?.body?.highlighter?.text?.substring(
															0,
															eccScreenData?.body?.highlighter?.text?.indexOf(
																"<"
															)
														)}
														<span
															className={clsx(
																"m-0 cursor-pointer text-[12px] font-semibold leading-[16px] text-[#AA4900] md:text-[14px] md:leading-[20px]"
															)}
														>
															&nbsp;Know more
														</span>
													</p>
												</div>
											</div>
										)}
									{/* Walk in eligible nudge */}
									{isWalkInJob && isCandidateEligible && (
										<div
											className="mb-[16px] flex w-full cursor-pointer items-center gap-[12px] rounded-[8px] bg-[#C1DBFB] p-[10px]"
											onClick={() => handleWalkInNudgeClick()}
										>
											<LightBulbIcon />
											<div className="flex w-full flex-1 items-center justify-between">
												<p className="m-0 text-[14px] font-semibold leading-[20px] text-[#172B4D]">
													Tips to get this job
												</p>
												<div className="rotate-180">
													<ChevronLeftIcon fill="#004BA9" />
												</div>
											</div>
										</div>
									)}
									{/* Walk in details section */}
									<div
										className={clsx("w-full space-y-[16px]", {
											"mb-[20px]": isMobileView,
										})}
									>
										{renderwalkInInterviewData(
											walkInInterviewDetails?.data
										)?.map((detail) => (
											<div
												className="flex w-full space-x-[8px]"
												key={detail?.title}
											>
												<div className="mt-[2px] md:mt-[3px]">
													<Image
														src={detail?.icon?.link}
														alt=""
														height={detail?.icon?.height}
														width={detail?.icon?.width}
													/>
												</div>
												<div className="flex-1">
													<p className="m-0 text-sm leading-[20px] text-[#8C8594] md:leading-[24px]">
														{detail?.title}
													</p>
													<p className="m-0 text-sm leading-[20px] text-[#190A28] md:leading-[24px]">
														{detail?.subtitle}
													</p>
												</div>
											</div>
										))}
										{isWalkInJob && (
											<p
												className="m-0 flex cursor-pointer items-center justify-center text-center text-[12px] font-semibold leading-[16px] text-[#1F8268]"
												onClick={() =>
													setShowAllWalkInDetails(
														!showAllWalkInDetails
													)
												}
											>
												{showAllWalkInDetails
													? "View less details"
													: "View more details"}
												<div
													className={clsx("", {
														"rotate-180":
															showAllWalkInDetails,
													})}
												>
													<ChevronDownIcon />
												</div>
											</p>
										)}
									</div>
									<div
										className={clsx(
											"my-[16px] h-[1px] w-full bg-[#E8E7EA]",
											{
												"hidden ": isMobileView,
											}
										)}
									/>
									{isMobileView && (
										<div
											className="w-full cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white"
											onClick={handleDownloadAppClick}
										>
											{isWalkInJob
												? "Download app to contact HR"
												: "Download Apna App"}
										</div>
									)}
									{!isMobileView && (
										<p
											className="m-0 cursor-pointer text-md font-semibold leading-[24px] text-[#1F8268]"
											onClick={handleDownloadAppClick}
										>
											{isWalkInJob
												? "Download app to contact HR"
												: "Download Apna App"}
										</p>
									)}
								</div>
								{showLowChanceElement &&
									!isMobileView &&
									!isWalkInJob && (
										<div
											className="flex cursor-pointer gap-[12px] rounded-b-md border border-t-0 border-solid bg-[#EBF3FE] p-[16px] md:mx-[108px]"
											onClick={() => setShowIneligibleModal(true)}
										>
											<InfoIcon size={16} fill="#003C96" />
											<div className="flex-1">
												<p className="m-0 text-xs font-semibold leading-[16px] text-[#003C96]">
													You may have low chances of getting
													this job
												</p>
												<p className="m-0 text-xs leading-[16px] text-[#827485]">
													While the HR has specific
													requirements, we found 10+ jobs below
													where you could be a top candidate
												</p>
											</div>
											<div className="solid h-max -rotate-90">
												<ChevronDownIcon fill="#190A28" />
											</div>
										</div>
									)}
							</div>
						)}
					</div>
					{/* This is shown only for RHR users */}
					{showLowChanceElement && isMobileView && !isWalkInJob && (
						<div
							className="flex w-full cursor-pointer gap-[12px] bg-[#EBF3FE] p-[16px] md:max-w-[688px]"
							onClick={() => setShowIneligibleModal(true)}
						>
							<InfoIcon size={16} fill="#003C96" />
							<div className="flex-1">
								<p className="m-0 text-xs font-semibold leading-[16px] text-[#003C96]">
									You may have low chances of getting this job
								</p>
								<p className="m-0 text-xs leading-[16px] text-[#827485]">
									While the HR has specific requirements, we found 10+
									jobs below where you could be a top candidate
								</p>
							</div>
							<div className="solid h-max -rotate-90">
								<ChevronDownIcon fill="#190A28" />
							</div>
						</div>
					)}
					{/* Job List Section */}
					{isJobFeedLoading && (
						<div className="my-[80px] flex items-center justify-center">
							<CircularProgress />
						</div>
					)}
					{isMobileView &&
						!isJobFeedLoading &&
						!(showJobFeed || showSimilarJobs) &&
						showPrimaryCTA() && (
							<div className="mx-[16px]">
								<div
									className="mx-auto my-[16px] flex w-full cursor-pointer items-center justify-center gap-[4px] rounded-[4px] bg-[#EAF8F4]"
									onClick={() => {
										redirectToJobFeed();
										handleClose();
										trackExploreBestMatchClick();
									}}
								>
									<p className="text-m m-0 p-[12px] font-semibold leading-[24px] text-[#1F8268]">
										Explore best match jobs
									</p>
									<div className="h-max w-max -rotate-90">
										<ChevronDownIcon />
									</div>
								</div>
							</div>
						)}
					{!isJobFeedLoading && (showJobFeed || showSimilarJobs) && (
						<div className="mx-auto px-[16px] py-[24px] md:w-[440px]">
							<p className="m-0 text-[20px] font-bold leading-[28px]">
								{isCandidateEligible
									? "Similar jobs"
									: "Jobs that match your profile"}
							</p>
							<div>
								{showSimilarJobs && (
									<div className="mt-[16px] space-y-[12px]">
										{similarJobs?.map((similarJob) => (
											<JobListCard
												job={similarJob}
												pageName={
													showSuccessSection
														? "job_application_successful_status_screen"
														: "job_application_unsuccessful_status_screen"
												}
											/>
										))}
									</div>
								)}
								{showJobFeed && (
									<div className="mt-[16px] space-y-[12px]">
										{jobFeedJobs?.map((feedJob) => (
											<JobListCard
												job={feedJob}
												pageName={
													showSuccessSection
														? "job_application_successful_status_screen"
														: "job_application_unsuccessful_status_screen"
												}
											/>
										))}
									</div>
								)}
							</div>
							{isMobileView && showPrimaryCTA() && (
								<div
									className="mx-auto my-[16px] flex w-full cursor-pointer items-center justify-center gap-[4px] rounded-[4px] bg-[#EAF8F4]"
									onClick={() => {
										redirectToJobFeed();
										handleClose();
										trackExploreBestMatchClick();
									}}
								>
									<p className="text-m m-0 p-[12px] font-semibold leading-[24px] text-[#1F8268]">
										Explore best match jobs
									</p>
									<div className="h-max w-max -rotate-90">
										<ChevronDownIcon />
									</div>
								</div>
							)}
						</div>
					)}

					{!isMobileView && !showIneligibleModal && showPrimaryCTA() && (
						<div className="sticky bottom-0 left-0 w-full border-t border-solid bg-white p-[24px]">
							<div
								className="mx-[116px] cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white"
								onClick={() => {
									redirectToJobFeed();
									handleClose();
									trackExploreBestMatchClick();
								}}
							>
								Explore best match jobs
							</div>
						</div>
					)}

					{/* For RHR users, we will show ineligible section when user clicks on low chance element */}
					{showIneligibleModal && (
						<div className="sticky bottom-0 left-0 z-20 h-auto w-full">
							<div
								className="flex cursor-pointer items-center justify-end px-[16px] py-[12px]"
								onClick={() => setShowIneligibleModal(false)}
							>
								<CrossWithBGIcon />
							</div>
							<div className="rounded-t-2xl bg-white pb-[16px]">
								<div className="space-y-[8px] p-[16px]">
									<p className="m-0 text-[20px] font-bold leading-[28px] text-[#190A28]">
										{highlightText}
									</p>
									<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
										{heading}
									</p>
								</div>
								<div className="mx-[16px] rounded-lg border border-solid border-[#CB2F4B] p-[12px]">
									<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
										This job requires:
									</p>
									<div className="mt-[12px] space-y-[12px]">
										{data?.requirements.map((reqObj) => (
											<div
												className={clsx(
													"mt-[12px] flex items-start"
												)}
											>
												<div className={clsx("mr-[10px]")}>
													<Image
														src={reqObj?.icon_link}
														alt="icon"
														width={16}
														height={16}
														layout="fixed"
													/>
												</div>
												<div>
													<div className="text-sm leading-[20px] text-[#190A28] md:text-md md:leading-[24px]">
														{reqObj?.title}
													</div>
													{reqObj?.sub_text && (
														<div className="text-sm leading-[20px] text-[#8C8594] md:text-md md:leading-[24px]">
															{reqObj?.sub_text}
														</div>
													)}
												</div>
											</div>
										))}
									</div>
								</div>
								{showPrimaryCTA() && (
									<div className="p-[16px]">
										<div
											className="w-full cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white"
											onClick={() => {
												redirectToJobFeed();
												handleClose();
												trackExploreBestMatchClick();
											}}
										>
											Explore best match jobs
										</div>
									</div>
								)}
							</div>
						</div>
					)}
					{/* Download App bottomsheet */}
					<ApplicationStatusBottomSheet
						open={showDowloadAppModal && !isMobileView}
						handleClose={() => setShowDowloadAppModal(false)}
						content={
							<div className="bg-white p-[24px]">
								<div className="mx-auto mb-[16px] flex w-[440px] items-center justify-between rounded-[16px] border border-solid border-[#E8E7EA] p-[24px] pb-[8px] shadow-200">
									<div className="flex flex-col">
										<p className="m-0 w-[200px] text-[20px] font-bold leading-[28px] text-[#190A28]">
											Scan the QR to download Apna
										</p>
										<p className="m-0 text-[16px] leading-[24px] text-[#190A28]">
											& get real time job updates
										</p>
										<div className="-ml-2">
											<Image
												loading="lazy"
												width={160}
												height={64}
												objectFit="cover"
												layout="fixed"
												src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
												alt="Get it on google play"
											/>
										</div>
									</div>
									<div className="relative h-[130px] w-[130px] object-cover">
										<CustomImage
											src="/cloudinary/sem_landing_page/Desktop%20Download%20APP%20Modal%20QR%20Code_QR-code.jpeg"
											layout="fill"
										/>
									</div>
								</div>
								<div className="mx-auto w-[440px]">
									<div
										className="w-full cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white"
										onClick={() => {
											setShowDowloadAppModal(false);
										}}
									>
										Done
									</div>
								</div>
							</div>
						}
					/>
					{/* Walk in ineligibility bottomsheet */}
					<ApplicationStatusBottomSheet
						open={showWalkInEligibleBs}
						handleClose={() => setShowWalkInEligibleBs(false)}
						content={
							!isCandidateEligible ? (
								<div
									className={clsx(" bg-white pt-[16px]", {
										"rounded-0 rounded-b-[8px]": !isMobileView,
										"rounded-t-[8px]": isMobileView,
									})}
								>
									<div className="mx-[16px] space-y-[8px] md:mx-[104px] md:text-center">
										<p className="m-0 text-[20px] font-bold leading-[28px] text-[#190A28]">
											{
												eccScreenData?.body?.highlighter
													?.meta_data?.title
											}
										</p>
										<p className="m-0 text-[14px] leading-[20px] text-[#8C8594]">
											{
												eccScreenData?.body?.highlighter
													?.meta_data?.sub_title
											}
										</p>
									</div>
									<div className="mx-[16px] mb-0 mt-[16px] max-w-[440px] rounded-lg border border-solid border-[#CB2F4B] p-[12px] md:mx-auto md:my-[24px]">
										<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
											{
												eccScreenData?.body?.highlighter
													?.meta_data?.in_eligible_jobs_data
													?.title
											}
										</p>
										<div className="mt-[12px] space-y-[12px]">
											{eccScreenData?.body?.highlighter?.meta_data?.in_eligible_jobs_data?.requirements?.map(
												(reqObj) => (
													<div
														className={clsx(
															"mt-[12px] flex items-start gap-[8px]"
														)}
													>
														<div>
															<Image
																src={reqObj?.icon_link}
																alt="icon"
																width={16}
																height={16}
																layout="fixed"
															/>
														</div>
														<div>
															<div className="text-sm leading-[20px] text-[#190A28]">
																{reqObj?.title}
															</div>
															{reqObj?.sub_text && (
																<div className="text-sm leading-[20px] text-[#8C8594]">
																	{reqObj?.sub_text}
																</div>
															)}
														</div>
													</div>
												)
											)}
										</div>
									</div>
									<div className="pb-[24px] pt-[16px] md:py-[24px] md:shadow-inner">
										<div
											className="mx-[16px] cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white md:mx-[124px]"
											onClick={handleDownloadAppClick}
										>
											Download app to contact HR
										</div>
									</div>
								</div>
							) : (
								<div
									className={clsx(" bg-white pt-[16px]", {
										"rounded-0 rounded-b-[8px]": !isMobileView,
										"rounded-t-[8px]": isMobileView,
									})}
								>
									<div className="mx-[16px] md:mx-[104px]">
										<p className="m-0 text-start text-[20px] font-bold leading-[28px] text-[#190A28] md:text-center">
											{
												eccScreenData?.body?.highlighter
													?.meta_data?.title
											}
										</p>
									</div>
									<div className="m-[16px] max-w-[440px] space-y-[16px] md:mx-[124px] md:my-[24px]">
										{eccScreenData?.body?.highlighter?.meta_data?.description_list?.map(
											(nudge) => (
												<div
													className="flex items-center gap-[16px]"
													key={nudge?.title}
												>
													<Image
														src={nudge?.icon_url}
														height={48}
														width={48}
													/>
													<p className="m-0 flex-1 text-[14px] leading-[20px] text-[#190A28] md:text-[16px] md:leading-[24px]">
														{nudge?.title}
													</p>
												</div>
											)
										)}
									</div>
									<div className="pb-[24px] md:py-[24px] md:shadow-inner">
										<div
											className="mx-[16px] cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[12px] text-center font-semibold text-white md:mx-[124px]"
											onClick={handleDownloadAppClick}
										>
											Download app to contact HR
										</div>
									</div>
								</div>
							)
						}
					/>
					{/* Overlay */}
					{(showIneligibleModal ||
						(showDowloadAppModal && !isMobileView) ||
						showWalkInEligibleBs) && (
						<div className="absolute bottom-0 left-0 top-0 z-10 min-h-screen w-full overflow-hidden bg-black opacity-70" />
					)}
				</div>
			</div>
		</Modal>
	);
};

export default ApplicationStatusScreen;
